import { WriteRight as EvaluationWriteRight } from '@pilot-web/pec-exam-evaluation'

export const Rights = [
    "WEB_MODULE_MY_PILOT_ASSIGNMENTS_WRITE",
    EvaluationWriteRight
]
